exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.cursor-pointer[data-v-ae08ca5c] {\n  cursor: pointer !important;\n}\n.feature-data-cell[data-v-ae08ca5c] {\n  position: relative;\n}\n.modal-wrapper[data-v-ae08ca5c] {\n  z-index: 1;\n  position: absolute;\n}\n.address-search[data-v-ae08ca5c] {\n  width: 300%;\n\n  top: calc(-100% - 10px);\n  transform: translate(-140%, 20px);\n}\n.option-wrap[data-v-ae08ca5c] {\n  max-width: 100%;\n  white-space: normal;\n  word-wrap: break-word !important;\n}\n.mg-left-2[data-v-ae08ca5c] {\n  margin-left: 2px;\n}\n.width200[data-v-ae08ca5c] {\n  width: 200px !important;\n}\n/* .table-responsive th{\n  width: 300px;\n} */\n", ""]);

// exports
